exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.text-dark[data-v-3c557185] {\n  font-weight: 600;\n  font-size: 12pt;\n  color: #000 !important;\n}\n.list-container[data-v-3c557185] {\n  height: 200px;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  font-size: 11pt;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3c557185","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/home/intervention/closed-org-settlement/ClosedOrgSettlement.vue
// module id = 667
// module chunks = 1